import {apiClient} from "@leap4/frontend"

export const ApiClient = apiClient;
